import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { usePopper } from "react-popper";
import { ClickableElementContainer } from "./styles";
import getPortalRoot from "../../util/getPortalRoot";
var BaseMenu = function(param) {
    var component = param.component, options = param.options, children = param.children, _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? false : _isOpen;
    var ref = useState(null), targetElement = ref[0], setTargetElement = ref[1];
    var ref1 = useState(null), menuElement = ref1[0], setMenuElement = ref1[1];
    var ref2;
    var placement = (ref2 = options === null || options === void 0 ? void 0 : options.placement) !== null && ref2 !== void 0 ? ref2 : "bottom";
    var ref3;
    var offset = (ref3 = options === null || options === void 0 ? void 0 : options.offset) !== null && ref3 !== void 0 ? ref3 : [
        0,
        10
    ];
    var ref4;
    var padding = (ref4 = options === null || options === void 0 ? void 0 : options.padding) !== null && ref4 !== void 0 ? ref4 : {
        left: 16,
        right: 16
    };
    var ref5 = useState(isOpen), isMenuOpen = ref5[0], setIsMenuOpen = ref5[1];
    var toggle = function() {
        setIsMenuOpen(function(prev) {
            return !prev;
        });
    };
    var open = function() {
        setIsMenuOpen(true);
    };
    var close = function() {
        setIsMenuOpen(false);
    };
    // Allow for component to be controlled
    useEffect(function() {
        setIsMenuOpen(isOpen);
    }, [
        isOpen,
        setIsMenuOpen
    ]);
    useEffect(function() {
        if (menuElement !== null && targetElement !== null) {
            var handleClickOutside = function(param) {
                var target = param.target;
                if (_instanceof(target, Node) && !menuElement.contains(target) && !targetElement.contains(target)) {
                    setIsMenuOpen(false);
                }
            };
            document.addEventListener("click", handleClickOutside);
            return function() {
                document.removeEventListener("click", handleClickOutside);
            };
        }
        return undefined;
    }, [
        menuElement,
        targetElement
    ]);
    var ref6 = usePopper(targetElement, menuElement, {
        placement: placement,
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            {
                name: "preventOverflow",
                options: {
                    padding: padding
                }
            }, 
        ]
    }), styles = ref6.styles, attributes = ref6.attributes;
    var menu = /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        ref: setMenuElement,
        style: styles.popper
    }, attributes.popper), {
        children: typeof children === "function" ? children({
            toggle: toggle,
            open: open,
            close: close
        }) : children
    }));
    var portal = getPortalRoot();
    var renderMenu = portal ? /*#__PURE__*/ createPortal(menu, portal) : menu;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(ClickableElementContainer, {
                ref: setTargetElement,
                onClick: toggle,
                children: component
            }),
            isMenuOpen && renderMenu
        ]
    });
};
export default BaseMenu;
